<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/shared/lib/utils"

// Презентаційний layout-блок дій. Mobile-first: кнопки в колонку зверху-вниз
// (основна дія першою у візуальному стеку), з sm — у рядок праворуч.
const props = defineProps<{ class?: HTMLAttributes["class"] }>()
</script>

<template>
  <div
    data-slot="sheet-footer"
    :class="
      cn(
        'mt-auto flex flex-col-reverse gap-2 sm:flex-row sm:justify-end',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
